
// src/session/SessionTimeoutContext.tsx
import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react'
import oktaAuth from '../oktaAuth.ts'
import { useLoading } from '../loader.jsx';


type TimeoutContextValue = {
  showTimeoutDialog: boolean
  openTimeoutModal: () => void
  closeModal: () => void
  handleOkAndLogout: () => Promise<void>
  handleReLogin: () => Promise<void>
}

const SessionTimeoutContext = createContext<TimeoutContextValue | null>(null)

export function useSessionTimeout() {
  const ctx = useContext(SessionTimeoutContext)
  if (!ctx) throw new Error('useSessionTimeout must be used within SessionTimeoutProvider')
  return ctx
}

export const SessionTimeoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { REACT_APP_OKTA_POST_LOGOUT_REDIRECTURI, REACT_APP_OKTA_HOST_URL } = process.env;
  const logoutUrl = REACT_APP_OKTA_POST_LOGOUT_REDIRECTURI;
  const reLoginUrl = REACT_APP_OKTA_HOST_URL;
  const [showTimeoutDialog, setShowTimeoutDialog] = useState(false)
  const hasActiveModalRef = useRef(false) // prevent multiple modals

  const openTimeoutModal = useCallback(() => {
    if (hasActiveModalRef.current) return
    hasActiveModalRef.current = true
    setShowTimeoutDialog(true)
  }, [])

  const closeModal = useCallback(() => {
    setShowTimeoutDialog(false)
    hasActiveModalRef.current = false
  }, [])

  const { showLoader, hideLoader } = useLoading();
  const handleReLogin = useCallback(async ()=> {
    showLoader()
    const storedVersion = localStorage.getItem("app_version");
    localStorage.clear();
    localStorage.setItem("app_version", storedVersion || "");
    const date = new Date();
    date.setTime(date.getTime() + 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = "logout= true;" + expires + ";path=/";
    setTimeout(async() => {
      try{
        oktaAuth.signOut({
          postLogoutRedirectUri: reLoginUrl,
        });
      }finally{
        setTimeout(()=>hideLoader(),1000)
      }
    }, 300);
  }, [closeModal])
  const handleOkAndLogout = useCallback(async () => {
    showLoader()
    const storedVersion = localStorage.getItem("app_version");
    localStorage.clear();
    localStorage.setItem("app_version", storedVersion || "");
    localStorage.setItem("logout", "true");
    const date = new Date();
    date.setTime(date.getTime() + 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = "logout= true;" + expires + ";path=/";
    setTimeout(async() => {
        try{
          await oktaAuth.signOut({
            postLogoutRedirectUri: logoutUrl,
          });
        }finally{
          setTimeout(()=>hideLoader(),1000)
        }
    }, 100);
    // try {
    //   closeModal();
    //   showLoader();
    //   await oktaAuth.signOut({
    //     postLogoutRedirectUri: logoutUrl,
    //   });
    // } finally {
    //   closeModal()
    //   hideLoader();
    //   window.location.replace('/login')
    //   oktaAuth.signOut({
    //     postLogoutRedirectUri: logoutUrl,
    //   });
    // }
  }, [closeModal])

  useEffect(() => {
    return () => {
      hasActiveModalRef.current = false
    }
  }, [])

  const value: TimeoutContextValue = {
    showTimeoutDialog,
    openTimeoutModal,
    closeModal,
    handleOkAndLogout,
    handleReLogin
  }

  return (
    <SessionTimeoutContext.Provider value={value}>
      {children}
    </SessionTimeoutContext.Provider>
  )
}

